"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Represents internal product of the company (only elementary attributes).
 *
 * @author Radek Beran
 */


var ProductNameAndCategories =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductNameAndCategories, _DomainObject_1$Domai);

  /**
   * Constructs product instance.
   *
   * @param id the internal id of product
   * @param externalId the external id of product, i.e. from source data, is used for pairing during data import
   * @param name
   * @param categoryIds List of product categories. The first one is lowest category, the last one is root.
   */
  function ProductNameAndCategories(id, externalId, name, categoryIds) {
    var _this;

    _classCallCheck(this, ProductNameAndCategories);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductNameAndCategories).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.categoryIds = categoryIds;
    return _this;
  }

  return ProductNameAndCategories;
}(DomainObject_1.DomainObject);

exports.ProductNameAndCategories = ProductNameAndCategories;
ProductNameAndCategories.projection = {
  _id: 1,
  externalId: 1,
  name: 1,
  categoryIds: 1
}; // tslint:disable-next-line:member-ordering

ProductNameAndCategories.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductNameAndCategories.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    name: builder.str('name'),
    categoryIds: builder.listOf(builder.id('categoryIds'))
  };
}();